import React from 'react';
import { SubscriptionWidgetItem } from '../../../../recently-viewed/src/template/src/subscription-widget-items';
import { FavouritedData } from '@atlassian/cssxp-typescommon';

type Subscriptions = FavouritedData[];

export const getFavouritedSubscriptionWidgetContent = (subscriptions: Subscriptions) => {
  if (!subscriptions || !subscriptions.length) {
    return <div style={{ marginTop: '15px' }}>No Subscriptions marked as favourites yet</div>;
  }

  return subscriptions.map((subscription, index) => {
    return <SubscriptionWidgetItem key={index} {...subscription} />;
  });
};
